/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsCveIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsCveIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsCveIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsCveIdQueryOperator>): AppSecopsCveIdQueryOperator {
        let obj = Object.assign(new AppSecopsCveIdQueryOperator(), model);
        AppSecopsCveIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsCveIdQueryOperator>): AppSecopsCveIdQueryOperator {
        if (!model) return null;
        return AppSecopsCveIdQueryOperator.newInstance(<AppSecopsCveIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsCveIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsCveIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsCveIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsCveIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CVE identifier associated with the vulnerability
     */
    cve_id: Array<string>;

}
